import { render, staticRenderFns } from "./PendingDialog.vue?vue&type=template&id=0820ce59"
import script from "./PendingDialog.vue?vue&type=script&lang=js"
export * from "./PendingDialog.vue?vue&type=script&lang=js"
import style0 from "./PendingDialog.vue?vue&type=style&index=0&id=0820ce59&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports